import React, { Component, createContext } from 'react';
var redirectURL = require('../components/redirectURL');

// Persisted separately from the legacy 'loading_port_code' / 'comp_code' localStorage keys,
// which several screens still read directly for audit/user-tracking fields (not for the
// currently-selected port). Keeping these distinct avoids changing that unrelated behavior
// while screens are migrated to this context one at a time.
const STORAGE_PORT_KEY = 'selected_loading_port_code';
const STORAGE_COMP_KEY = 'selected_comp_code';

export const LoadingPortContext = createContext({
    loading_port_code: '',
    comp_code: '',
    lpNames: [],
    setLoadingPort: () => {},
    setLpNames: () => {},
});

export class LoadingPortProvider extends Component {
    constructor(props) {
        super(props);

        var lpNames = [];
        try {
            lpNames = JSON.parse(localStorage.getItem('loadingPointName')) || [];
        } catch (e) {
            lpNames = [];
        }

        this.state = {
            loading_port_code: localStorage.getItem(STORAGE_PORT_KEY) || localStorage.getItem('loading_port_code') || '',
            comp_code: localStorage.getItem(STORAGE_COMP_KEY) || localStorage.getItem('comp_code') || '',
            lpNames: lpNames,
        };
    }

    setLoadingPort = (loading_port_code, comp_code) => {
        localStorage.setItem(STORAGE_PORT_KEY, loading_port_code || '');
        this.setState((prevState) => {
            var nextCompCode = comp_code !== undefined ? comp_code : prevState.comp_code;
            localStorage.setItem(STORAGE_COMP_KEY, nextCompCode || '');
            return {
                loading_port_code: loading_port_code,
                comp_code: nextCompCode,
            };
        });
    }

    setLpNames = (lpNames) => {
        this.setState({ lpNames: lpNames || [] });
    }

    render() {
        var value = {
            loading_port_code: this.state.loading_port_code,
            comp_code: this.state.comp_code,
            lpNames: this.state.lpNames,
            setLoadingPort: this.setLoadingPort,
            setLpNames: this.setLpNames,
        };
        return (
            <LoadingPortContext.Provider value={value}>
                {this.props.children}
            </LoadingPortContext.Provider>
        );
    }
}

// Shared admin/non-admin page-access + loading-port resolution, so individual screens
// don't each carry their own copy of this branching. Resolves to null when there is
// nothing further for the caller to do (no access - already alerted+redirected; empty
// port list; or a request error already logged) - callers should just return in that case.
// `portContext` is the value from LoadingPortContext (i.e. `this.context` in a consumer).
export function resolvePageAccess(currentUrl, portContext) {
    return new Promise((resolve) => {
        var is_dept_admin = localStorage.getItem("is_department_admin");
        var role = localStorage.getItem("roles");

        function pickLoadingPort(lpNames, source) {
            var selloading_port_code = portContext.loading_port_code;
            if (selloading_port_code != undefined && selloading_port_code != '' &&
                lpNames.some(each => each.loading_port_code == selloading_port_code)) {
                return selloading_port_code;
            }
            return source.length > 0 ? source[0].loading_port_code : '';
        }

        if (role.indexOf("lm_site_admin") >= 0 || is_dept_admin == 1 || role.indexOf("lm_admin") >= 0) {
            redirectURL.post("/lmconsignees/getLmLoadingPorts").then((response2) => {
                var lpData = response2.data;
                if (!(lpData.length > 0)) {
                    resolve(null);
                    return;
                }
                var lpNames = [];
                lpData.map((item) => {
                    if (item.comp_short_name != '' && item.comp_short_name != undefined) {
                        lpNames.push({
                            loading_port_code: item.loading_port_code,
                            loading_port: item.comp_short_name,
                            value: item.loading_port_code,
                            label: item.comp_short_name,
                        })
                    }
                })
                var loading_port_code = pickLoadingPort(lpNames, lpData);
                var filterChkCode = loading_port_code.includes("GUR") ? "GUR" : loading_port_code;
                var result1 = lpData.filter(obj => obj.loading_port_code == filterChkCode);
                var comp_code = result1.length > 0 ? result1[0].comp_code : lpData[0].comp_code;

                portContext.setLoadingPort(loading_port_code, comp_code);
                portContext.setLpNames(lpNames);
                resolve({ pageAccess: 3, loading_port_code, comp_code, lpNames });
            }).catch((e) => {
                console.log(e);
                resolve(null);
            })
        }
        else {
            var query = {
                "userid": localStorage.getItem("userid"),
                "menu_url": currentUrl,
            }
            redirectURL.post("/lmconsignees/checkUserCurrentPageAccess", query).then((response) => {
                var result = response.data;
                if (!(result.length > 0)) {
                    alert("You Don't have access to this screen, Please request access")
                    window.location.href = "/lmpageaccess";
                    // Deliberately never resolve here - the page is about to be replaced by
                    // navigation, so the caller's `await` should stay pending rather than
                    // resuming and hiding the loading overlay (which would flash the empty
                    // underlying page just before the redirect actually happens).
                    return;
                }
                var pageAccess = 2;
                var lpNames = [];
                var gurArray = result.filter((e) => e.loading_port_code == "GUR");
                var ncrArray = result.filter((f) => f.loading_port_code == "GUR-2");
                var rpdcArray = result.filter((g) => g.loading_port_code == "RPDCGUR");
                result.map((item) => {
                    if (item.loading_port_name != '' && item.loading_port_name != undefined) {
                        lpNames.push({
                            loading_port_code: item.loading_port_code,
                            loading_port: item.loading_port_name,
                            value: item.loading_port_code,
                            label: item.loading_port_name,
                        })
                    }
                })
                if (gurArray.length > 0) {
                    if (ncrArray.length == 0) {
                        lpNames.push({ loading_port_code: "GUR-2", loading_port: "DELHI-NCR", value: "GUR-2", label: "DELHI-NCR" })
                    }
                    if (rpdcArray.length == 0) {
                        lpNames.push({ loading_port_code: "RPDCGUR", loading_port: "RPDC-Gurgaon", value: "RPDCGUR", label: "RPDC-Gurgaon" })
                    }
                }
                var loading_port_code = pickLoadingPort(lpNames, result);
                var filterChkCode = loading_port_code.includes("GUR") ? "GUR" : loading_port_code;
                var result1 = result.filter(obj => obj.loading_port_code == filterChkCode);
                var comp_code;
                if (result1.length > 0) {
                    if (result1[0].access != '' && result1[0].access != undefined) {
                        pageAccess = result1[0].access;
                    }
                    comp_code = result1[0].comp_code;
                } else {
                    if (result[0].access != '' && result[0].access != undefined) {
                        pageAccess = result[0].access;
                    }
                    comp_code = result[0].comp_code;
                }

                portContext.setLoadingPort(loading_port_code, comp_code);
                portContext.setLpNames(lpNames);
                resolve({ pageAccess, loading_port_code, comp_code, lpNames });
            }).catch((e) => {
                console.log(e);
                resolve(null);
            })
        }
    });
}
